import { axios } from "../config/axios";

const endPoint = '/project/venue-master';

const getVenueListByPage = (search, page, limit) => {
    return axios.post(`${endPoint}/pagination`, {
        search: search,
        page: page,
        limit: limit,
    });
}

const getVenueById = async (venueId) => {
    return axios.get(`${endPoint}/${venueId}`);
}

const createVenue = async (body) => {
    return axios.post(`${endPoint}`, body);
}

const updateVenueById = async (venueId, body) => {
    return axios.put(`${endPoint}/${venueId}`, body);
}

const deleteVenueById = async (venueId) => {
    return axios.delete(`${endPoint}/${venueId}`);
}

export {
    getVenueListByPage,
    getVenueById,
    createVenue,
    updateVenueById,
    deleteVenueById,
}
